import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-attachment-url"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 3 }

import {computed} from 'vue';
import {IMessageAttachment} from "~/chat/ts/data/chat/IMessage";
import ChatAudioPlayButton from "~/chat/vue/widget/tabs/chat/ChatAudioPlayButton.vue";
import ChatMessageFileContentDescription from "~/chat/vue/widget/tabs/chat/ChatMessageFileContentDescription.vue";
import Htmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import StringHelper from "~/ts/library/StringHelper";
import {SVG_LOADER_ANIMATION} from "~/chat/vue/widget/tabs/chat/SvgLoaderAnimation";


const __default__ = {
    name: "ChatMessageFileContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    attachment: {}
  },
  emits: ["height-increase"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;


let url = computed(() => {
    let result = props.attachment.url
        .split("//download.me-talk.ru/")
        .join("//download.site-chat.me/");
    if (result != props.attachment.url) {
        props.attachment.url = result;
    }
    return result;
});

let isAudio = computed(() => {
    return props.attachment.type == "audio";
});

let isVideo = computed(() => {
    return props.attachment.type == "video";
});

let isImage = computed(() => {
    return props.attachment.type == "image";
});

let styleForImageWrapper = computed(() => {
    let imageSize = props.attachment.imageSize;
    if (imageSize) {
        let w = imageSize.width;
        let h = imageSize.height;
        return `--attach-image-width: ${w}px; --attach-image-aspect-ratio: ${w} / ${h};`;
    }
    return null;
})

let attachHtml = computed(() => {
    let name = StringHelper.htmlEntities(props.attachment.fileName);
    let url = props.attachment.url;
    let loader = '';
    if (styleForImageWrapper.value) {
        loader = SVG_LOADER_ANIMATION;
    }
    return `<a href="${url}" target="_blank" class="attachment-html"><span class="name">${name}</span><span class="loader">${loader}</span></a>`;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "attachment",
    "data-attachment-url": _unref(url)
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isAudio) || _unref(isVideo) ? 'div' : 'a'), {
      href: _unref(url),
      class: _normalizeClass({
                'cursor-pointer': !_unref(isAudio) && !_unref(isVideo)
            }),
      target: "_blank"
    }, {
      default: _withCtx(() => [
        (_unref(isAudio))
          ? (_openBlock(), _createBlock(ChatAudioPlayButton, {
              key: 0,
              attachment: _ctx.attachment
            }, null, 8, ["attachment"]))
          : (_unref(isVideo))
            ? (_openBlock(), _createElementBlock("video", {
                key: 1,
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                controls: "",
                src: _ctx.attachment.url
              }, null, 8, _hoisted_2))
            : (_unref(isImage))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  style: _normalizeStyle(_unref(styleForImageWrapper)),
                  class: _normalizeClass({
                    'image-wrapper-with-size': !!_unref(styleForImageWrapper)
                })
                }, [
                  _createVNode(Htmlify, {
                    escape: false,
                    value: _unref(attachHtml),
                    snippet: "",
                    onHeightIncrease: _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('height-increase', $event)))
                  }, null, 8, ["value"])
                ], 6))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(ChatMessageFileContentDescription, { attachment: _ctx.attachment }, null, 8, ["attachment"])
                ]))
      ]),
      _: 1
    }, 8, ["href", "class"]))
  ], 8, _hoisted_1))
}
}

})